export enum CurrencyPreference {
  HeartsFirst = 'heartsFirst',
  SapphiresFirst = 'sapphiresFirst',
  HeartsOnly = 'heartsOnly',
  SapphiresOnly = 'sapphiresOnly',
}
